<!-- eslint-disable vue/multi-word-component-names -->
<template>

  <div class="container">
    <div class="nav-bar">
      <div class="nav-item" :class="{ active: $route.path === '/main' }" @click="goTo('/main')">Alpha π计划</div>
      <div class="nav-item" :class="{ active: $route.path === '/domp' }" @click="goTo('/domp')">Viva la différence</div>
      <div class="nav-item" :class="{ active: $route.path === '/domp/YeasCard' }" @click="goTo('/domp/YeasCard')">关于阳狮
      </div>
    </div>
    <div class="con">
      <img class="conimg" src="@/assets/mainbuttonlb.png" alt="">
      <img class="conimg conimge" src="@/assets/mainbuttonllb.png" alt="">
    </div>
    <div class="box">
      <img class="topleft" src="@/assets/dlbe.png" alt="">
      <img class="bottomleft" src="@/assets/tou.png" alt="">
      <img class="bottomright" src="@/assets/ewm.png" alt="">
      <img class="btopmain" src="@/assets/title.png" alt="">
      <img class="maine" src="@/assets/titlemin.png" alt="">
    </div>

    <div class="header">
      <router-view />
    </div>
  </div>
</template>

<script setup>

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import { useRouter } from 'vue-router'
import { ref } from 'vue'

const router = useRouter()
const isDomp = ref(true)
const isDompe = ref(false)

const goTo = (path) => {
  router.push(path)
  window.scrollTo(0, 0)
  isDomp.value = path === '/domp'
  isDompe.value = path === '/domp/YeasCard'
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}

html,
body {
  overflow-x: hidden;
}

.container {
  max-width: 100vw;
  overflow-x: hidden;
}

.container {
  width: 100%;
  margin: 0;
  padding: 0;
  position: relative;
}

.con {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 1420px;
  height: auto;
  display: block;
}

.conimg {
  width: 1350px;
}

.conimge {
  /* position: absolute;
  bottom: 0;
  left: 42%; */
  width: 85%;
  height: auto;
  display: none;
}

.box {
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  position: relative;
  margin-top: 40px;
}

img {
  display: block;
  height: auto;
}

.topleft {
  position: absolute;
  left: 0;
  top: 0;
  width: 15%;
}

.bottomleft {
  position: absolute;
  left: 3%;
  bottom: 0;
  width: 30%;
}

.bottomright {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 28%;
}

.btopmain {
  position: absolute;
  top: 9%;
  left: 50%;
  transform: translateX(-50%);
  width: 60%;
  height: auto;
}

.maine {
  position: absolute;
  top: 80%;
  left: 53%;
  transform: translate(-50%, -50%);
  width: 25%;
}

.header {
  margin: 0;
  padding: 0;
  width: 100%;
  height: auto;
}

.nav-bar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background: #F87373;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 60px;
  z-index: 9999;
}

.nav-item {
  cursor: pointer;
  font-size: 16px;
  color: #333;
  transition: color 0.3s ease;
  font-family: 'Noto Sans SC', sans-serif;
  font-weight: 350;
}

.nav-itemhover {
  color: #fff;
}

/* ====================== 完整保留移动端样式 ====================== */
@media (max-width: 768px) {

  .nav-bar {
    height: 50px;
    gap: 15px;
    padding: 0 10px;
  }

  .nav-item {
    font-size: 12px;
  }

  .box {
    width: 100%;
    height: 200px;
    margin-top: 50px;
  }

  .btopmain {
    width: 60%;
    height: auto;
  }

  .maine {
    top: 80%;
  }

  .header {
    width: 100%;
  }

  .conimg {
    display: none;
  }

  .conimge {
    display: block;
    width: 85%;
  }

  .con {
    width: 375px;
  }
}

.nav-item.active {
  color: #fff;
}
</style>